<template>
    <div>
        <v-container class="mainRender" grid-list-md fluid>
            <v-row dense>
                <v-col cols="12">
                    <v-card class="mb-4">
                        <v-card-title class="py-3 grey lighten-4 d-flex align-center">
                            <b>FILTROS</b>
                            <v-spacer></v-spacer>
                            <v-btn small text @click="showAdvanced = !showAdvanced">
                                <v-icon small>{{ showAdvanced ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                Filtros avanzados
                            </v-btn>
                        </v-card-title>
                        <v-card-text class="pa-4">
                            <v-row dense align="center">
                                <v-col cols="12" sm="3">
                                    <v-autocomplete dense v-model="tipoFiltro" :items="opcionesFiltro"
                                        item-text="text" item-value="id" label="Filtrar por" hide-details="auto" />
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-menu v-model="menuFechaInicio" :close-on-content-click="false"
                                        transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                        <template #activator="{ on, attrs }">
                                            <v-text-field v-model="fechaInicio" dense label="Fecha Inicio"
                                                prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                                hide-details="auto" clearable />
                                        </template>
                                        <v-date-picker v-model="fechaInicio" no-title scrollable
                                            @input="menuFechaInicio = false" />
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-menu v-model="menuFechaFin" :close-on-content-click="false"
                                        transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                        <template #activator="{ on, attrs }">
                                            <v-text-field v-model="fechaFin" dense label="Fecha Fin"
                                                prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                                hide-details="auto" clearable />
                                        </template>
                                        <v-date-picker v-model="fechaFin" no-title scrollable
                                            @input="menuFechaFin = false" />
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select dense v-model="filtroIdEstado" :items="$store.state.inventario.listaEstados"
                                        item-text="description" item-value="id" label="ESTADO"
                                        hide-details="auto" clearable
                                        @change="getReservas({ state: true })" />
                                </v-col>
                            </v-row>
                            <v-expand-transition>
                                <v-row v-if="showAdvanced" dense align="center" class="mt-3">
                                    <v-col cols="12" sm="3">
                                        <v-text-field dense v-model="filtroIdVenta" label="NRO TICKET"
                                            hide-details="auto" clearable type="number"
                                            @keyup.enter="getReservas({ state: true })"
                                            @click:clear="filtroIdVenta = null; getReservas({ state: true })" />
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-text-field dense v-model="filtroNombreCliente" label="CLIENTE"
                                            hide-details="auto" clearable
                                            @keyup.enter="getReservas({ state: true })"
                                            @click:clear="filtroNombreCliente = null; getReservas({ state: true })" />
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-text-field dense v-model="filtroNumeroDocumento" label="DOC. CLIENTE"
                                            hide-details="auto" clearable
                                            @keyup.enter="getReservas({ state: true })"
                                            @click:clear="filtroNumeroDocumento = null; getReservas({ state: true })" />
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-select dense v-model="filtroPlataforma" :items="plataformasOptions"
                                            label="PLATAFORMA" hide-details="auto" clearable
                                            @change="getReservas({ state: true })" />
                                    </v-col>
                                </v-row>
                            </v-expand-transition>
                            <v-expand-transition>
                                <v-row v-if="showAdvanced" dense align="center" class="mt-3">
                                    <v-col cols="12" sm="3">
                                        <v-text-field dense v-model="filtroIdCotizacion" label="NRO COTIZACION"
                                            hide-details="auto" clearable type="number"
                                            @keyup.enter="getReservas({ state: true })"
                                            @click:clear="filtroIdCotizacion = null; getReservas({ state: true })" />
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-text-field dense v-model="filtroIdOrdenCompra" label="ORDEN COMPRA"
                                            hide-details="auto" clearable
                                            @keyup.enter="getReservas({ state: true })"
                                            @click:clear="filtroIdOrdenCompra = null; getReservas({ state: true })" />
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-text-field dense v-model="filtroNumeroComprobante" label="NRO COMPROBANTE"
                                            hide-details="auto" clearable
                                            @keyup.enter="getReservas({ state: true })"
                                            @click:clear="filtroNumeroComprobante = null; getReservas({ state: true })" />
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-text-field dense v-model="filtroDescripcion" label="DESCRIPCION"
                                            hide-details="auto" clearable
                                            @keyup.enter="getReservas({ state: true })"
                                            @click:clear="filtroDescripcion = null; getReservas({ state: true })" />
                                    </v-col>
                                </v-row>
                            </v-expand-transition>
                            <v-row dense align="center" class="mt-3">
                                <v-col cols="12" sm="2" class="d-flex align-center">
                                    <v-btn small color="primary" dark :loading="loading" @click="getReservas({ state: true })">
                                        BUSCAR <v-icon right small>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" sm="2" class="d-flex align-center" v-if="optionalRole.isDownload">
                                    <v-btn small color="blue" dark :loading="loadingDownload" @click="downloadHandle">
                                        XLSX <v-icon right small>mdi-download</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <TableReservas title="HISTORICO" :lista="filteredData"
                        :itemsPerPage="itemsPerPage"
                        :search.sync="quickSearch"
                        @update:options="onTableOptions"
                        @refresh="getReservas({})"></TableReservas>
                </v-col>
            </v-row>
        </v-container>
        <ActionDial></ActionDial>

        <v-dialog v-model="modalReserva.state" scrollable max-width="1024" persistent>
            <ModalReserva v-if="modalReserva.state" />
        </v-dialog>

        <v-dialog v-model="modalHistorialEstado.state" scrollable max-width="900" persistent>
            <ModalHistorialEstado v-if="modalHistorialEstado.state" :idVenta="modalHistorialEstado.idVenta" />
        </v-dialog>

        <v-dialog v-model="modalDatosEnvio.state" scrollable max-width="1100" persistent>
            <ModalDatosEnvio v-if="modalDatosEnvio.state" />
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { format, subMonths, addMonths } from 'date-fns'
import { exportXLSX } from '@/utils'
import TableReservas from '@/components/reservas/TableReservas'
import ModalReserva from '@/components/modals/ModalReserva'
import ModalHistorialEstado from '@/components/modals/ModalHistorialEstado'
import ModalDatosEnvio from '@/components/modals/ModalDatosEnvio'
import ActionDial from '@/components/ActionDial'

export default {
    components: {
        ModalReserva,
        ModalHistorialEstado,
        ModalDatosEnvio,
        TableReservas,
        ActionDial
    },
    data: () => ({
        loading: false,
        loadingDownload: false,
        showAdvanced: false,
        filteredData: [],
        datenow: '',
        tipoFiltro: 3,
        opcionesFiltro: [
            { id: 3, text: 'Fecha Creacion' },
            { id: 4, text: 'Fecha Entrega/Finalizacion' }
        ],
        fechaInicio: format(subMonths(new Date(), 1), 'yyyy-MM-dd'),
        fechaFin: format(addMonths(new Date(), 1), 'yyyy-MM-dd'),
        menuFechaInicio: false,
        menuFechaFin: false,
        filtroIdVenta: null,
        filtroIdCotizacion: null,
        filtroNombreCliente: null,
        filtroNumeroDocumento: null,
        filtroIdOrdenCompra: null,
        filtroDescripcion: null,
        filtroNumeroComprobante: null,
        filtroIdEstado: null,
        quickSearch: null,
        filtroPlataforma: null,
        plataformasOptions: [
            'Reserva por WSP', 'Reserva presencial', 'Sodimac', 'Venta Wsp',
            'Saga Falabella', 'Reserva Telefonica', 'Reserva wsp',
            'Tienda Fisica', 'Cubaspa.com', 'Web', 'Tienda',
            'Mercado Libre', 'woocommerce', 'kuntesoluciones.com'
        ],
        page: 1,
        itemsPerPage: 20,
    }),
    computed: {
        ...mapState('ventas', ['modalReserva', 'modalHistorialEstado', 'modalDatosEnvio']),
        ...mapState('users', ['user']),
        ...mapGetters('users', ['optionalRole']),
    },
    async created() {
        this.$store.commit('ventas/SHOW_MODAL', { step: 1, state: false })
        this.$store.dispatch('users/getLista')
        this.$store.dispatch('inventario/estados')
        this.$store.dispatch('sedes/detailsAllUbigeo')
        await this.getInitialValues()
        this.$root.$on('refresh-reservas', this.getReservas)
    },
    beforeDestroy() {
        this.$root.$off('refresh-reservas', this.getReservas)
    },
    methods: {
        onTableOptions({ page, itemsPerPage }) {
            this.page = page
            this.itemsPerPage = itemsPerPage
        },
        async getInitialValues() {
            const { idBussines } = this.user
            const items = [this.getReservas({}), this.$store.dispatch('sedes/getDepartamento', { online: true })]
            if (idBussines == 1) {
            }
            await Promise.all(items)
        },
        async getReservas({ state, skip, limit } = {}) {
            this.loading = true
            const result = await this.$store.dispatch('ventas/getReservasV2', {
                fechaInicio: this.fechaInicio,
                fechaFin: this.fechaFin,
                tipoFiltro: this.tipoFiltro,
                skip: 0,
                limit: 0,
                idVenta: this.filtroIdVenta || undefined,
                idCotizacion: this.filtroIdCotizacion || undefined,
                numeroDocumento: this.filtroNumeroDocumento || undefined,
                nombreCliente: this.filtroNombreCliente || undefined,
                idOrdenCompra: this.filtroIdOrdenCompra || undefined,
                descripcion: this.filtroDescripcion || undefined,
                numeroComprobante: this.filtroNumeroComprobante || undefined,
                idEstado: this.filtroIdEstado || undefined,
                web_online: this.filtroPlataforma || undefined,
            })
            let data = result.data || []
            if (this.user.id_role == 6 && this.optionalRole?.newVendor) {
                data = data.filter((x) => x.idColaborador == this.user.id)
            }
            this.filteredData = data
            this.loading = false
        },
        async downloadHandle() {
            this.loadingDownload = true
            const result = await this.$store.dispatch('ventas/getReservasV2', {
                fechaInicio: this.fechaInicio,
                fechaFin: this.fechaFin,
                skip: 0,
                limit: 0,
                idVenta: this.filtroIdVenta || undefined,
                idCotizacion: this.filtroIdCotizacion || undefined,
                numeroDocumento: this.filtroNumeroDocumento || undefined,
                nombreCliente: this.filtroNombreCliente || undefined,
                idOrdenCompra: this.filtroIdOrdenCompra || undefined,
                descripcion: this.filtroDescripcion || undefined,
                numeroComprobante: this.filtroNumeroComprobante || undefined,
                idEstado: this.filtroIdEstado || undefined,
                web_online: this.filtroPlataforma || undefined,
            })
            const items = this._formatExportData(result.data)
            const filename = `Historial Ventas ${this.fechaInicio} _ ${this.fechaFin}`
            const headers = [
                'TICKET', 'Estados', 'Numero de Comprobante', 'Orden de Compra',
                'Plataforma', 'Sede', 'Vendedor', 'Fecha Creación',
                'Fecha Entrega/Fin', 'Descripcion', 'Proveedor', 'Cliente', 'Tipo Monedo',
                'Total a Pagar', 'Total Pagado (S/)', 'Total Pagado ($)',
                'Cotizacion', 'FormaEntrega', 'Codigo Interno'
            ]
            const campos = [
                'id', 'descEstado', 'numeroComprobante', 'idOrdenCompra',
                'web_online', 'sedeDetail', 'nombreColaborador', 'fechaCreacion',
                'check_in', '_description', 'supplier_name', '_full_name', 'idTipoMoneda',
                'importeTotal', 'importeAbonadoSoles', 'importeAbonadoDolares',
                'cotOC', 'formaEntregaDesc', 'internalId'
            ]
            exportXLSX({ headers, campos, arrayData: items }, { filename })
            this.loadingDownload = false
        },
        _formatExportData(data) {
            if (!data || !Array.isArray(data)) return []
            return data.map((v) => {
                const userAssignment = this.$store.state.users.listaUser.find(
                    (x) => x.id == (v.idUserAssignment || v.idColaborador)
                )
                let nameProduct = ''
                let internalId = ''
                let supplierName = ''
                const source = v.productos
                if (source && source.length > 0) {
                    const first = typeof source === 'string' ? JSON.parse(source)[0] : source[0]
                    nameProduct = first ? first.name || first.description || first.descSodimac || first.rename || first.second_name || '' : ''
                    internalId = first ? first.internal_id : ''
                    supplierName = first ? first.supplier_name || '' : ''
                }
                const ubigeo = v.ubigeo ? this.$store.state.sedes.ubigeos?.find((w) => w.id == v.ubigeo) : null
                const nombreDist = ubigeo ? ubigeo.name : ''
                return {
                    ...v,
                    idTipoMoneda: v.idTipoMoneda == 1 ? 'S/.' : '$',
                    importeTotal: Number(v.importeTotal) || 0,
                    importeAbonadoSoles: Number(v.importeAbonadoSoles) || 0,
                    importeAbonadoDolares: Number(v.importeAbonadoDolares) || 0,
                    efectivo: Number(v.efectivo) || 0,
                    tarjeta: Number(v.tarjeta) || 0,
                    transferencia: Number(v.transferencia) || 0,
                    adelanto: Number(v.adelanto) || 0,
                    cotOC: v.idCotizacion,
                    _id: `T-${v.id}`,
                    _full_name: v.full_name ? v.full_name.slice(0, 25) : '',
                    _description: nameProduct,
                    supplier_name: supplierName,
                    internalId,
                    UserAssignment: userAssignment
                        ? `${userAssignment.nombres} ${userAssignment.apellidos}`
                        : 'FIORELLA CHECCLLO',
                    formaEntregaDesc: v.formaEntrega
                        ? `${this.$store.state.utilities.tipoFormaEntrega?.find((x) => x.id == v.formaEntrega)?.text} - ${nombreDist}`
                        : null,
                }
            })
        },
    }
}
</script>
<style scoped>
.stickyToolbar {
    position: -webkit-sticky !important;
    position: -moz-sticky !important;
    position: -ms-sticky !important;
    position: -o-sticky !important;
    position: sticky !important;
    top: 64px !important;
    z-index: 2;
}
.borderTable {
    border: 1px solid #f5f5f5;
}
@media only screen and (min-width: 1440px) {
    .mainRender {
        min-width: 1500px;
    }
}
</style>
